import React from 'react';
import _ from 'lodash';

import CardEspeciales from '../CardEspeciales/index';
import BotonGhostPublicaciones from '../BotonGhostPublicaciones/index';

import './css/styles.css';

class PanelPublicaciones extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            objetosPublicaciones: [],
        }
    }

    componentWillMount(){
        fetch('/api/uip/publicaciones/principal/todos', {
            method: 'GET',
            headers:{
              'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(data => this.setState({ objetosPublicaciones: data }))
            .catch(err => console.log(err))
    }

    render(){

        let count = 1;
        const objEsp = [];
        const objetosEsp = _.map(this.state.objetosPublicaciones, (data, i) => {
            let push_pull;
            if(count === 1){
                push_pull = `push-m1`;
                objEsp[0] =
                    <CardEspeciales 
                        titulo={data.titulo}
                        frase={data.frase}
                        url={data.url}
                        index={data.imagen}
                        push_pull={push_pull}
                        key={i}/>;
                
                count = count + 1;

                if(this.state.objetosPublicaciones.length==(i+1)){
                    return(
                        <div className="row">
                            {objEsp[0]}
                        </div>
                    );
                }
            }
            else if(count === 3){
                push_pull = `pull-m1`;
                objEsp[2] =
                    <CardEspeciales 
                        titulo={data.titulo}
                        frase={data.frase}
                        url={data.url}
                        index={data.imagen}
                        push_pull={push_pull}
                        key={i}/>;
                
                count = 1;

                return(
                    <div className="row">
                        {objEsp[0]}
                        {objEsp[1]}
                        {objEsp[2]}
                    </div>
                );
            }
            else {
                push_pull = ``;
                objEsp[1] =
                    <CardEspeciales 
                        titulo={data.titulo}
                        frase={data.frase}
                        url={data.url}
                        index={data.imagen}
                        push_pull={push_pull}
                        key={i}/>;
                
                count = count + 1;

                if(this.state.objetosPublicaciones.length==(i+1)){
                    return(
                        <div className="row">
                            {objEsp[0]}
                            {objEsp[1]}
                        </div>
                    );
                }
            }
            
            
        })

        return(
            <section className="background_panel_publicaciones_principal">
                <BotonGhostPublicaciones text="publicaciones"
                                         boxLeft="s12 m3 l5"
                                         boxCenter="s12 m6 l2"
                                         boxRight="s12 m3 l5" />
                {objetosEsp}
            </section>
        );
    }
}

export default PanelPublicaciones;